module.exports = __webpack_public_path__ + "img/nodatos.65a2cd98.jpg";